import isEmpty from 'lodash/isEmpty';
import { emptyObject, emptyList } from '@constants/empty';

export const getModalState = ({ combats }) => combats.modal;

export const getFirstPreference =
  (goalUID) =>
  ({ combats }) =>
    combats.onboardingPreferences?.[goalUID]?.[0]?.options || emptyList;

export const getIsEnrolled =
  (combatUID) =>
  ({ combats }) =>
    combats.enrolled?.[combatUID] || false;

export const getCombatDetails =
  (combatUID) =>
  ({ combats }) =>
    combats.details?.[combatUID] || emptyList;

export const getCombats =
  (key) =>
  ({ paginator }) =>
    paginator.combats?.[key] || emptyObject;

export const getHasCombat = (goalUID) => (state) => {
  const firstPreference = getFirstPreference(goalUID)(state);

  if (isEmpty(firstPreference)) {
    return false;
  }

  return true;
};

export const getCombatRating =
  (goalUID) =>
  ({ combats }) =>
    combats.myRating?.[goalUID] || emptyObject;
